import bilAPI from "../api";

export const getTeams = ({
  uuid,
  region,
  exam_center,
  status,
  team_member_search,
  name,
  is_passed,
  level,
  page,
  page_size,
  ordering,
  signal,
}) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get(`/olympiad/teams/${uuid ? uuid + "/" : ""}`, {
          params: {
            region: region,
            exam_center: exam_center,
            status: status,
            team_member_search: team_member_search,
            name: name,
            is_passed: is_passed,
            level: level,
            page: page,
            page_size: page_size,
            ordering: ordering,
          },
          signal,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const postTeam = (body) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .post(`/olympiad/teams/`, body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const postTeamMember = (teamUuid, body) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .post(`/olympiad/teams/${teamUuid}/add_member/`, body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const postApproveTeam = (teamUuid) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .post(`/olympiad/teams/${teamUuid}/approve/`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const patchTeam = (uuid, body) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .patch(`/olympiad/teams/${uuid}/`, body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const deleteTeam = (uuid) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .delete(`/olympiad/teams/${uuid}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};
